// extracted by mini-css-extract-plugin
export default {"videoItem":"video-item__videoItem--UR4br"};